import { FormSkeleton } from "@ui/external/components/skeleton";
import {
  getTableInfo,
  showToast,
  throwErrorAlert,
} from "@utils/helper/index.helper";
import { usePathname } from "@utils/hook/index.hook";
import { useEffect, useState } from "react";
import SettingsCard from "./_components/settins-card";
import SettingsModal from "./_components/settings-modal";
import { DiffEmailSettings, FetchSiteSettings } from "@services/SiteSettingServices";
import { useQuery } from "@tanstack/react-query";

interface Setting {
  id: string
  title: string
  description: string
  fields: Array<{
    id?: string | number
    name: string
    label: string
    type: "text" | "email" | "textarea" | "select"
    placeholder?: string
    options?: Array<{ value: string; label: string }>
  }>
}

const SETTINGS: Setting[] = [
  {
    id: "home-header-footer",
    title: "Home Header Footer",
    description: "Update home page header footer",
    fields: [
       {
        name: "header_code",
        label: "Header Code",
        type: "textarea",
        placeholder: "Header code here ..",
      },
      {
        name: "footer_code",
        label: "Footer Code",
        type: "textarea",
        placeholder: "Footer code here ..",
      },
    ],
  },
  {
    id: "payment-email",
    title: "Payment Email",
    description: "Manage your payment email",
    fields: [
      {
        name: "email",
        label: "Payment Email",
        type: "email",
        placeholder: "payment@example.com",
      },
    ]
  },
  {
    id: "teams-email",
    title: "Microsoft Teams Email and Password",
    description: "Manage your Microsoft Teams email",
    fields: [
      {
        name: "email",
        label: "Microsoft Teams",
        type: "email",
        placeholder: "teams@example.com",
      },
    ]
  },
  {
    id: "certificate-email",
    title: "Certificate Email",
    description: "Manage your Certificate Email",
    fields: [
      {
        name: "email",
        label: "Certificate Email",
        type: "email",
        placeholder: "certificate@example.com",
      },
    ]
  },
]


const index = () => {
  const [openModal, setOpenModal] = useState<string | null>(null)
  const [formData, setFormData] = useState<Record<string, Record<string, string>>>({})
  const pathname = usePathname();

  const { data: headerFooterCode } = useQuery({
    queryKey: ['site-settings-header-footer'], 
    queryFn: FetchSiteSettings, 
  });
  const { data: diffEmails } = useQuery({
    queryKey: ['diff-emails'], 
    queryFn: DiffEmailSettings, 
  });


 useEffect(() => {
  if (headerFooterCode?.data) {
    setFormData({
      "home-header-footer": {
        header_code: headerFooterCode.data.header_code || "",
        footer_code: headerFooterCode.data.footer_code || ""
      }
    });
  }
}, [headerFooterCode?.data]);

useEffect(() => {
  if (diffEmails?.data?.results) {
    const results = diffEmails.data.results;
    setFormData(prev => ({
      ...prev,
      "payment-email": {
        id:results[0]?.id,
        email: results[0]?.emails || ""
      },
      "teams-email": {
        id:results[1]?.id,
        email: results[1]?.emails || ""
      },
      "certificate-email": {
        id:results[2]?.id,
        email: results[2]?.emails || ""
      }
    }));
  }
}, [diffEmails?.data]);


  const result = getTableInfo({
    mode: "default",
    type: pathname || "",
  }) as { title: string; description: string };
  let { title, description } = result;

  const handleOpenModal = (settingId: string) => {
    setOpenModal(settingId)
  }

  const handleCloseModal = () => {
    setOpenModal(null)
  }

  const handleSave = (settingId: string, data: Record<string, string>) => {
    setFormData((prev) => ({
      ...prev,
      [settingId]: data,
    }))
    handleCloseModal()
  }


  const currentSetting = SETTINGS.find((s) => s.id === openModal);

  if (false)
    return (
      <>
        <FormSkeleton />
      </>
    );

  return (
    <div className=" ">
      <div className="flex justify-between items-start">
        <ul className="list-none">
          {<li className="text-[32px] font-[500]">{title}</li>}
          {<li className="text-[#7B7679] text-[14px]">{description}</li>}
        </ul>
      </div>

              {/* Settings Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {SETTINGS.map((setting) => (
            <SettingsCard
              key={setting.id}
              title={setting.title}
              description={setting.description}
              onEdit={() => handleOpenModal(setting.id)}
            />
          ))}
        </div>
      
      {currentSetting && (
        <SettingsModal
          isOpen={openModal !== null}
          onClose={handleCloseModal}
          setting={currentSetting}
          onSave={(data) => handleSave(currentSetting.id, data)}
          initialData={formData[currentSetting.id] || {}}
        />
      )}
    </div>
  );
};

export default index;
